// 英文版《用户服务协议》——内联 HTML。
// 用 srcDoc 直接注入 iframe，避免依赖 public/ 静态文件（真机/部署环境下新文件未及时下发时会出现 404 → SPA 兜底变成登录页）。
export default `       
<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>ODance User Service Agreement</title>
    <style>
        /* Reset & Base */
        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
        }

        body {
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "PingFang SC", "Microsoft YaHei", sans-serif;
            background-color: #f8f9fc;
            color: #1e293b;
            line-height: 1.7;
            padding: 24px 16px;
        }

        .container {
            max-width: 860px;
            margin: 0 auto;
            background: #ffffff;
            border-radius: 20px;
            box-shadow: 0 8px 30px rgba(0, 0, 0, 0.05);
            padding: 40px 38px;
        }

        /* Headings */
        h1 {
            font-size: 28px;
            font-weight: 700;
            letter-spacing: -0.3px;
            color: #0f172a;
            margin-bottom: 6px;
            text-align: center;
        }

        .subhead {
            text-align: center;
            font-size: 15px;
            color: #64748b;
            border-bottom: 1px solid #e9edf2;
            padding-bottom: 20px;
            margin-bottom: 28px;
        }

        .subhead span {
            display: inline-block;
            margin: 0 12px;
        }

        h2 {
            font-size: 20px;
            font-weight: 600;
            color: #0f172a;
            margin-top: 34px;
            margin-bottom: 16px;
            padding-bottom: 6px;
            border-bottom: 2px solid #eef2f6;
        }

        h3 {
            font-size: 17px;
            font-weight: 600;
            color: #1e293b;
            margin-top: 22px;
            margin-bottom: 8px;
        }

        p {
            margin-bottom: 14px;
            font-size: 15px;
            color: #334155;
        }

        /* Lists */
        ul, ol {
            padding-left: 24px;
            margin-bottom: 16px;
        }

        li {
            margin-bottom: 8px;
            font-size: 15px;
            color: #334155;
        }

        .list-dense li {
            margin-bottom: 4px;
        }

        /* Ordered list with numbering */
        .num-list {
            list-style: none;
            padding-left: 0;
            counter-reset: item;
        }

        .num-list > li {
            counter-increment: item;
            padding-left: 32px;
            position: relative;
            margin-bottom: 12px;
        }

        .num-list > li::before {
            content: counter(item) ".";
            position: absolute;
            left: 0;
            font-weight: 600;
            color: #0f172a;
        }

        .sub-list {
            list-style: none;
            padding-left: 28px;
            counter-reset: subitem;
        }

        .sub-list > li {
            counter-increment: subitem;
            padding-left: 28px;
            position: relative;
            margin-bottom: 6px;
        }

        .sub-list > li::before {
            content: counter(subitem, lower-alpha) ".";
            position: absolute;
            left: 0;
            color: #475569;
        }

        /* Table */
        .table-wrap {
            overflow-x: auto;
            margin: 18px 0;
            border-radius: 12px;
            border: 1px solid #e9edf2;
        }

        table {
            width: 100%;
            border-collapse: collapse;
            font-size: 15px;
        }

        th, td {
            padding: 12px 16px;
            text-align: left;
            border-bottom: 1px solid #e9edf2;
        }

        th {
            background-color: #f8fafc;
            font-weight: 600;
            color: #0f172a;
        }

        tr:last-child td {
            border-bottom: none;
        }

        .table-note {
            font-size: 14px;
            color: #64748b;
            margin-top: 8px;
        }

        /* Highlight box */
        .highlight-box {
            background-color: #f1f5f9;
            border-left: 4px solid #3b82f6;
            padding: 16px 20px;
            border-radius: 8px;
            margin: 20px 0;
        }

        .highlight-box p {
            margin-bottom: 6px;
        }

        /* Contact card */
        .contact-card {
            background: #f8fafc;
            border-radius: 12px;
            padding: 18px 22px;
            margin: 16px 0 8px;
            border: 1px solid #e9edf2;
        }

        .contact-card p {
            margin-bottom: 4px;
        }

        .contact-card .label {
            font-weight: 500;
            color: #0f172a;
            display: inline-block;
            min-width: 70px;
        }

        /* Footer */
        .footer-note {
            text-align: center;
            color: #94a3b8;
            font-size: 14px;
            margin-top: 40px;
            padding-top: 20px;
            border-top: 1px solid #e9edf2;
        }

        /* Responsive */
        @media (max-width: 600px) {
            .container {
                padding: 24px 18px;
            }

            h1 {
                font-size: 22px;
            }

            h2 {
                font-size: 18px;
            }

            .subhead {
                font-size: 13px;
            }

            .subhead span {
                display: block;
                margin: 4px 0;
            }

            th, td {
                padding: 10px 12px;
                font-size: 14px;
            }
        }

        /* Inline code */
        .inline-code {
            background: #f1f5f9;
            padding: 0 8px;
            border-radius: 4px;
            font-family: monospace;
            font-size: 14px;
            color: #0f172a;
        }
    </style>
</head>
<body>

    <div class="container">

        <!-- Title & Dates -->
        <h1>ODance User Service Agreement</h1>
        <div class="subhead">
            <span>Updated: October 19, 2026</span>
            <span>Effective: October 19, 2026</span>
        </div>

        <!-- Introduction -->
        <p>Welcome to ODance (hereinafter referred to as the “Service”). This Agreement is a legal contract between you and us (the operator) regarding your use of the Service through the “BOOTER” APP. Please read and fully understand this Agreement. If you do not agree to any term of this Agreement, please do not use the Service.</p>

        <!-- 1. Account Registration and Use -->
        <h2>1. Account Registration and Use</h2>
        <ul class="num-list">
            <li>The Service is divided into a Domestic Version and an Overseas Version according to the application interface language (for example, the Simplified Chinese interface is the Domestic Version, and a non-Simplified Chinese interface is the Overseas Version, subject to what is displayed on the login page). The Domestic Version supports registration/login via mobile phone number or email address; the Overseas Version supports registration/login via email address only. After switching languages, the available login methods may change accordingly; accounts registered before switching can still log in or bind according to the page prompts. The Overseas Version does not provide mobile phone number login.</li>
            <li>You need to register or log in through the “BOOTER” APP to use the Service, and you must ensure that the registration information you provide is true, accurate, and complete (mobile phone number and/or email address), and update it in a timely manner. If you log in with an email address, you should ensure that the email address is real, valid, and able to normally receive verification codes and service notifications.</li>
            <li>Please keep your account and verification codes (including SMS verification codes and email verification codes) safe. You may not transfer or lend them to others. Losses caused by your own disclosure of account information or verification codes, account lending, shared use, attacks by others, fraud, etc., shall be borne by you.</li>
            <li>You confirm that you have full civil capacity. If you are a minor, please read this Agreement with your guardian and obtain your guardian’s consent.</li>
        </ul>

        <!-- 2. Service Content -->
        <h2>2. Service Content</h2>
        <ul class="num-list">
            <li>
                The Service provides the following robot dance-related functions:
                <ul style="margin-top:6px;">
                    <li>Users upload videos, and AI training generates dance models;</li>
                    <li>Dance models are delivered to robots to control the robot’s dance movements.</li>
                </ul>
            </li>
            <li>We may adjust or suspend part of the Service as needed, and we will notify you in advance via in-app announcements or email.</li>
            <li>
                When using dance execution, real-time control, and other functions, you must ensure that the robot’s operating environment is safe, free of obstacles, and free of people nearby. We are not liable for equipment damage, personal injury, or property loss caused by reasons not attributable to us (including but not limited to improper operation by you, improper selection of environment, hardware failure or aging of the robot itself).
            </li>
            <li>
                Dance models generated by the Service are automatically generated by AI algorithms. We do not guarantee that the generated movements fully conform to physical laws or aesthetic expectations, nor do we guarantee that the robot will execute them completely stably. If the robot falls or is damaged due to the execution of such AI-generated content, you should evaluate the feasibility yourself and bear the operational risk; for repair or replacement of related hardware, please contact the hardware manufacturer directly.
            </li>
        </ul>

        <!-- 3. Paid Services -->
        <h2>3. Paid Services</h2>
        <ul class="num-list">
            <li>
                <strong>Billing method:</strong> Digital services in this app, such as generating dance videos and dance models, are consumed using “Oakcoin” as virtual currency.
            </li>
            <li>
                <strong>Per-second billing rule:</strong> All generation services in this app are billed by dance duration (seconds). There is no fixed one-price package. After you click “Confirm Generation,” the system will deduct the corresponding Oakcoin in real time according to the selected service type. The specific standards are as follows:
                <div class="table-wrap">
                    <table>
                        <thead>
                            <tr>
                                <th>Consumption Item (Generation Type)</th>
                                <th>Included Content</th>
                                <th>Amount Consumed (Billed per Second)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Generate Complete Dance</td>
                                <td>Dance Model + Simulated Video</td>
                                <td>210 Oakcoin per second (i.e., the sum of the first two items)</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </li>
            <li>
                <strong>Payment, Delivery, and Refunds:</strong> Oakcoin is a virtual commodity. After a successful recharge, it cannot be refunded or exchanged back into RMB. After you click “Confirm Generation,” the system will immediately deduct the corresponding Oakcoin. Because generation services are virtual digital content, Oakcoin already deducted after generation will not be refunded.
            </li>
            <li>
                <strong>Validity period:</strong> Oakcoin is valid for a long term from the date of successful recharge and has no expiration date. We may adjust billing standards based on business development needs, but this will not affect the balance of Oakcoin you have already purchased or the use of content you have already generated.
            </li>
            <li>
                <strong>Malicious refund behavior:</strong> If you engage in malicious refund behavior (such as fabricating quality issues, providing false evidence, abusing refund policies, etc.), we have the right to suspend some of your functions after verification; if this causes actual losses to the platform (such as payment channel refund fees, penalties imposed by the channel, etc.), we have the right to directly deduct them from the fees you have paid. In cases of serious or repeated malicious refunds, we have the right to permanently ban your account and the right to use generated models, and no longer provide the Service.
            </li>
        </ul>

        <!-- 4. User Conduct Rules -->
        <h2>4. User Conduct Rules</h2>
        <p>When using the Service, you must not:</p>
        <ul>
            <li>Upload videos, images, audio, or other content that is illegal, infringing, pornographic, violent, or infringes the lawful rights and interests of others;</li>
            <li>Use the Service to engage in any illegal or criminal activities;</li>
            <li>Interfere with the normal operation of the Service, or attempt to crack or reverse engineer any part of the Service;</li>
            <li>Use any automated program or script to maliciously access the Service;</li>
            <li>When the robot is executing dance movements, intentionally place the robot in a dangerous environment or improperly guide others.</li>
        </ul>
        <p>If you violate the above rules, we have the right to delete or block the relevant content, suspend or terminate your account depending on the circumstances, and reserve the right to pursue legal liability.</p>
        <p><strong>Intellectual property infringement complaints:</strong> If you believe that content in the Service infringes your lawful rights and interests, you may send an infringement notice and preliminary proof materials to support@oakcreektech.com, and we will handle it in accordance with the law after verification.</p>
        <p><strong>Account appeals:</strong> If your account is subject to restrictive measures and you object, you may appeal through the above email within 7 days, and we will review and reply within 15 working days.</p>

        <!-- 5. Intellectual Property -->
        <h2>5. Intellectual Property</h2>
        <ul class="num-list">
            <li>
                <strong>The Service itself and all related elements</strong> (including but not limited to software, code, interface design, trademarks, logos, text, images, audio, built-in dance templates, algorithm logic, databases, voice synthesis timbres, etc.) and all intellectual property and related rights are exclusively owned by us. Without our written permission, no one may use, copy, distribute, or reverse engineer them in any form.
            </li>
            <li>
                <strong>Content you upload:</strong> The copyright of the demonstration videos you upload remains yours. You agree to grant us a worldwide, non-exclusive, non-transferable license, solely for: (a) generating the agreed dance model or simulated video for you; (b) improving the Service algorithm (feature extraction and model training on videos). We will not use your uploaded content for advertising or for other users’ services. You promise that the content you upload does not infringe any third-party rights. If this causes us losses (including attorney fees, settlement amounts, etc.), you shall fully compensate us.
            </li>
            <li>
                <strong>Content generated by the Service:</strong> The intellectual property and related rights of all content generated by the Service (including but not limited to dance models and simulated videos) are exclusively owned by us. You only enjoy the usage rights expressly agreed in this Agreement, as follows:
                <ul>
                    <li>Platform built-in free dance templates: free to use;</li>
                    <li>Dance models you pay to generate: you obtain permanent usage rights, but may not resell, sublicense, or claim to own their intellectual property;</li>
                    <li>Simulated videos you pay to generate: you obtain a personal non-commercial use license, limited to viewing in the app or for non-public personal learning/display, and you may not resell, sublicense, publicly publish, or claim to own their intellectual property.</li>
                </ul>
            </li>
        </ul>

        <!-- 6. Disclaimer -->
        <h2>6. Disclaimer</h2>
        <ul class="num-list">
            <li>The Service needs to be used with your own robot hardware. We are not liable for service abnormalities or losses caused by force majeure, third-party service interruptions, your own equipment or network failures, or other reasons not due to our intentional or gross negligence. If losses are caused by defects in our system, we will bear corresponding liability in accordance with the law.</li>
            <li>We cannot guarantee that the Service will be completely uninterrupted, absolutely secure, or error-free, nor can we guarantee that generated dance models, movement execution, etc., will fully meet your expectations or be safe and applicable in all environments.</li>
            <li>To the maximum extent permitted by law, we do not bear any indirect or incidental losses. You acknowledge and agree that robot hardware is provided by third parties, and the operator of the Service does not bear hardware-related quality assurance, safety responsibilities, or after-sales obligations.</li>
        </ul>

        <!-- 7. Modification and Termination of the Agreement -->
        <h2>7. Modification and Termination of the Agreement</h2>
        <ul class="num-list">
            <li>We may modify this Agreement from time to time. The modified Agreement will be notified to you through in-app pop-ups, site messages, or email. Your continued use of the Service means you agree to the modified Agreement.</li>
            <li>You may cancel your account in the personal center of the “BOOTER” APP, or contact us at support@oakcreektech.com to apply for cancellation. After account cancellation, we will delete your personal information within a reasonable period (including your mobile phone number and/or email address, etc., except where laws and regulations require retention).</li>
        </ul>

        <!-- 8. Governing Law and Dispute Resolution -->
        <h2>8. Governing Law and Dispute Resolution</h2>
        <p>This Agreement is governed by the laws of the People’s Republic of China. Any dispute arising from or related to this Agreement shall first be resolved through friendly negotiation between the parties; if negotiation fails, either party has the right to file a lawsuit with the people’s court with jurisdiction in the defendant’s domicile.</p>

        <!-- 9. Contact Us -->
        <h2>9. Contact Us</h2>
        <div class="contact-card">
            <p><span class="label">📧 Email:</span> support@oakcreektech.com</p>
            <p><span class="label">📍 Address:</span> Room 207, Entrepreneurship Building, Tsinghua Science Park, Wudaokou, Haidian District, Beijing</p>
            <p><span class="label">🏢 Company:</span> Beijing OakCreek Technology Co., Ltd.</p>
        </div>
        <p style="margin-top:8px;">Thank you for using ODance!</p>

        <!-- Footer -->
        <div class="footer-note">
            ODance · Provided by Oakay · Embedded in the “BOOTER” APP
        </div>

    </div>

</body>
</html>

    

    
`;
